export const MENU_SERVICE_URL = '/ws-menu'
